import(/* webpackMode: "eager" */ "/vercel/path0/src/app/company/page.tsx");
